import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { customAxios } from "lib/axios";

export interface DirectorTeamLeaveStatsData {
  pendingRequests: number;
  approvedToday: number;
  onLeaveToday: number;
  rejectedLast7Days: number;
  upcomingLeaves: number;
}

export interface DirectorTeamLeaveStatsResponse {
  success: boolean;
  data: DirectorTeamLeaveStatsData;
  message?: string;
}

const getDirectorTeamLeaveStats = async (): Promise<DirectorTeamLeaveStatsResponse> => {
  const { data } = await customAxios.get<DirectorTeamLeaveStatsResponse>(
    "/leaves/director/team/stats"
  );
  return data;
};

export const useGetDirectorTeamLeaveStats = () =>
  useQuery<DirectorTeamLeaveStatsResponse, AxiosError>(
    ["director-team-leave-stats"],
    () => getDirectorTeamLeaveStats(),
    {
      staleTime: 60000, // 1 minute
      retry: 1,
      refetchOnWindowFocus: false,
    }
  );
